import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../Home/Footer";
import HeroSection from "./HeroSection";
import OurStorySection from "./OurStorySection";
import MIssionVisionSection from "./MIssion&VisionSection";
import LeaderShipTeamSection from "./LeaderShipTeamSection";
import LegacyInNumberSection from "./LegacyInNumberSection";
import BuildLegacySection from "./BuildLegacySection";
import ScrollToTopButton from "../../Components/ScrollToTopButton";
import { Box } from "@mui/material";
import useMetaTags from "../../Hooks/UseMetaTags";

const AboutUs = () => {
  useMetaTags({
    title: "About Us | Our Story & Visionaries",
    description: "Learn more about Abilio Realty, our legacy of architectural innovation, mission & vision, and the executive leadership leading our growth.",
    keywords: "about abilio realty, executive team, mission and vision, real estate history, property development legacy",
    ogTitle: "About Us | Our Story & Visionaries | Abilio Realty",
    ogDescription: "Discover our journey, architectural philosophy, and the leaders shaping the future of global real estate.",
  });

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#000000" }}>
      <Navbar />
      <HeroSection />
      <OurStorySection />
      <MIssionVisionSection />
      <LeaderShipTeamSection />
      <LegacyInNumberSection />
      <BuildLegacySection />

      {/* You can add more sub-components here later (e.g. <QuestionSection />, <TeamSection />) */}

      <Footer />
      <ScrollToTopButton />
    </Box>
  );
};

export default AboutUs;
